import cx from 'classnames';
import PropTypes from 'prop-types';

const Divider = ({ className = '' }) => (
  <hr className={cx('yst-my-6', className)} />
);

Divider.propTypes = {
  className: PropTypes.string,
};

export default Divider;
